// Import Libraries
import React from "react";
import PageSEO from "../../../../Components/SEO/PageSEO";

// Import Components
import ServerUpgradesComponent from "./Components/ServerUpgradesComponent/ServerUpgradesComponent";

const ServerUpgradesPage = () => {
  // Define structured data for the page
  const serverUpgradesSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "WebNX Server Upgrades",
    "description": "Comprehensive server upgrade options including memory, storage, GPUs, and operating systems. Upgrade your WebNX dedicated servers with our extensive inventory of AMD & Intel processors, DDR3 & DDR4 ECC RAM, and enterprise-grade storage solutions.",
    "offers": {
      "@type": "AggregateOffer",
      "offers": [
        {
          "@type": "Offer",
          "name": "Memory Upgrades",
          "description": "DDR3 & DDR4 ECC RAM upgrades starting at $1 per GB"
        },
        {
          "@type": "Offer",
          "name": "Storage Upgrades",
          "description": "SSD, NVMe, and HDD upgrades with RAID options"
        },
        {
          "@type": "Offer",
          "name": "GPU Upgrades",
          "description": "Custom GPU configurations for specialized workloads"
        },
        {
          "@type": "Offer",
          "name": "Operating System Upgrades",
          "description": "Windows Server and Linux distributions"
        }
      ]
    },
    "features": [
      "Memory Upgrades",
      "Storage Solutions",
      "GPU Integration",
      "Operating Systems",
      "RAID Configurations",
      "Remote Management"
    ],
    "brand": {
      "@type": "Brand",
      "name": "WebNX"
    },
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "Memory Options",
        "value": "DDR3 & DDR4 ECC RAM"
      },
      {
        "@type": "PropertyValue",
        "name": "Storage Types",
        "value": "SSD, NVMe, HDD, SATA"
      },
      {
        "@type": "PropertyValue",
        "name": "RAID Options",
        "value": "RAID 0/1/5/6/10 with BBU"
      },
      {
        "@type": "PropertyValue",
        "name": "OS Support",
        "value": "Windows Server, CentOS, Debian, Ubuntu, and more"
      }
    ]
  };

  return (
    <div>
      <PageSEO
        title="Server Upgrades | Enhance Your WebNX Dedicated Servers"
        description="Upgrade your WebNX dedicated servers with our comprehensive upgrade options. From memory and storage to GPUs and operating systems, customize your server for peak performance. Extensive inventory of AMD & Intel processors, DDR3 & DDR4 ECC RAM, and enterprise-grade storage solutions."
        keywords="server upgrades, WebNX upgrades, memory upgrades, storage upgrades, GPU upgrades, operating system upgrades, RAID upgrades, server customization, dedicated server upgrades, enterprise hardware upgrades"
        path="/server-upgrades"
        image="https://webnx.com/assets/server-upgrades.jpg"
        schema={serverUpgradesSchema}
        socialProfiles={{
          facebook: "https://www.facebook.com/WebNX/",
          linkedin: "https://www.linkedin.com/company/webnx/"
        }}
      />

      <ServerUpgradesComponent />
    </div>
  );
};

export default ServerUpgradesPage;
